/**
 * Breakpoint values for setting the Justified Gallery stretch ranges. These are different than the viewport breakpoints since this is based on the container width of JustifiedGallery. These should line up with the container media queries in justifiedGallery.css.
 */
export const JUSTIFIED_GALLERY_BREAKPOINTS = {
  sm: 320,
  md: 768,
  lg: 1024,
  xl: 1800,
} as const;

// Default height values for items that span the entire page
// e.g., Search results page
export const JUSTIFIED_GALLERY_DEFAULT_HEIGHTS = {
  sm: 185,
  md: 215,
  lg: 215,
  xl: 245,
};

// Default height values for items that are centered with a large margin or are condensed for other reasons.
// e.g., Details related search
export const CONDENSED_JUSTIFIED_GALLERY_HEIGHTS = {
  sm: 165,
  md: 165,
  lg: 215,
  xl: 240,
};

// Height values for vertical orientation videos
export const VERTICAL_JUSTIFIED_GALLERY_HEIGHTS = {
  sm: 230,
  md: 355,
  lg: 355,
  xl: 480,
};
